import { Component, OnInit, ViewChild } from '@angular/core';
import { TypeTableHelper } from './helpers/type-table-helper';
import { GlobalFilterService,
         AuthorizationService,
         AuditVendorService,
         AuditTypeService} from 'src/app/services';
import { Table } from 'primeng/table';
import { dropRight } from 'lodash';
import { Pagination,
         AuditVendor } from 'src/app/models';
import { LazyLoadEvent } from 'primeng/api';
import { TypeToolbarHelper } from './helpers/type-toolbar.helper';
import { ToolbarAction } from 'src/app/shared/models/toolbarAction';
import { ModalAction } from 'src/app/shared/models/modalAction';
import * as toastr from 'toastr';
import { AdminModalAction } from '../shared/models/adminModalAction';
import { AuditType } from 'src/app/models/audit-type';
import { BusinessResponseService } from 'src/app/services/business-response.service';

@Component({
  selector: 'app-audit-type',
  templateUrl: './audit-type.component.html',
  styleUrls: ['./audit-type.component.css']
})
export class AuditTypeComponent implements OnInit {
  public readonly tableHelper: TypeTableHelper;
  public readonly toolbarHelper: TypeToolbarHelper;
  public readonly max_rows = 30;
  public readonly viewFeatures = [{ feature: 'UI::AuditTypeDelete', name: 'delete', accessable: false},
                                  { feature: 'UI::AuditTypeEdit', name: 'edit', accessable: false }];
  public deleteText = '';
  public readonly deleteTitle = 'Delete Confirmation';
  public tableLoading: boolean;
  public confirmDelete: boolean;
  public auditTypes: AuditType[];
  public totalItemCount: number;
  public deleteAllowed: boolean;
  public showAddEditDialog: boolean;
  public editDialogTitle: string;
  public editId: string;
  public auditTypeName: string;
  public auditTypeId: number;
  constructor(private auditTypeService: AuditTypeService,
              private authService: AuthorizationService,
              private globalFilterService: GlobalFilterService,
              private businessRespService: BusinessResponseService) {
    this.tableHelper = new TypeTableHelper();
    this.toolbarHelper = new TypeToolbarHelper(this.authService);
    this.globalFilterService.ClientChanged.subscribe(() => this.onClientsChanged());
  }

  @ViewChild('dt', { static: true }) dTable: Table;

  ngOnInit() {
    this.tableLoading = true;
    this.checkFeatures();
  }

  private checkFeatures(): void {
    for ( let i = 0; i < this.viewFeatures.length; i++) {
      if (this.authService.hasFeature(this.viewFeatures[i].feature)) {
        this.viewFeatures[i].accessable = true;
      }
    }
    if ( !this.viewFeatures[0].accessable) {
      this.tableHelper.tableColumns = dropRight(this.tableHelper.tableColumns);
    }
  }

  loadDataLazy(event: LazyLoadEvent): void {
    if (!this.tableLoading) {
      this.tableLoading = true;
    }

    this.auditTypeService.getAuditTypesLimitedResult
      (new Pagination(this.max_rows, event.first, event.sortField, event.sortOrder))
      .subscribe( (data) => {
        this.auditTypes = data.Items;
        this.totalItemCount = data.TotalItemCount;
        this.tableLoading = false;
      }, (error) => {
        this.tableLoading = false;
      });
  }

  onClientsChanged(): void {
    if (this.dTable) {
      this.dTable.reset();
      this.tableLoading = true;
    }
  }

  toolbarBtnClick(event: ToolbarAction) {
    switch (event.index) {
      case 0: {
        this.dTable.reset();
        break;
      } case 1: {
        this.handleDialogs('add');
      }
    }
  }

  clickName(name: string, id: number) {
    this.auditTypeName = name;
    this.auditTypeId = id;
    this.handleDialogs('edit');
  }

  deleteClicked(rowData: AuditType): void {
    this.auditTypeId = rowData.AuditTypeId;
    this.deleteText = `Are you sure that you want to delete <strong>${rowData.Name}</strong>?`;
    this.handleDialogs('delete');
  }

  handleDialogs(name: string) {
    if (name === 'edit') {
      this.editDialogTitle = 'Edit Audit Type';
      this.editId = 'edit';
      this.showAddEditDialog = true;
    }

    if (name === 'add') {
      this.auditTypeName = null;
      this.editDialogTitle = 'Add New Audit Type';
      this.editId = 'add';
      this.showAddEditDialog = true;
    }

    if ( name === 'delete') {
      this.confirmDelete = true;
    }
  }

  deleteCallback(event: ModalAction): void {
    if (event.action === 'cancel') {
      this.confirmDelete = false;
      return;
    }
    this.auditTypeService.deleteAuditType(this.auditTypeId)
      .subscribe( (response) => {
        toastr.success('Type was deleted successfully!');
        this.resetAuditType();
        this.dTable.reset();
        this.confirmDelete = false;
      }, () => {
        toastr.error('We are not able to delete the type at this time.');
      });
    }

  editCallback(event: AdminModalAction): void {
    if (event.action === 'cancel') {
      this.showAddEditDialog = false;
      return;
    }
    if (event.action === 'update') {
      this.auditTypeService.updateAuditType(this.auditTypeId, event.nameValue)
        .subscribe( (response) => {
          if (this.businessRespService.handleBusinessResponse('Update type name successful!', response)) {
            this.resetAuditType();
            this.dTable.reset();
            this.showAddEditDialog = false;
          }
        }, () => {
          toastr.error('We are not able to update the type name at this time.');
        });
    }

    if (event.action === 'add') {
      this.auditTypeService.addAuditType(event.nameValue)
        .subscribe( (response) => {
          if (this.businessRespService.handleBusinessResponse('Add type successful!', response)) {
            this.resetAuditType();
            this.dTable.reset();
            this.showAddEditDialog = false;
          }
        }, () => {
          toastr.error('We are not able to add the type at this time.');
        });
    }
  }

  resetAuditType(): void {
    this.auditTypeId = null;
    this.auditTypeName = '';
  }
}
